'use strict';
var $def      = require('./$.def')
  , $includes = require('./$.array-includes')(true);
$def($def.P, 'Array', {
  // https://github.com/domenic/Array.prototype.includes
  includes: function includes(el /*, fromIndex = 0 */){
    return $includes(this, el, arguments[1]);
  }
});
require('./$.unscope')('includes');


/*****************
 ** WEBPACK FOOTER
 ** /Users/spikelny/Desktop/projects/art/fastcash/~/babel-core/~/core-js/modules/es7.array.includes.js
 ** module id = 165
 ** module chunks = 0
 **/